import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "filename", "removeFlag"]
  static values = {
    previewUrl: String,
    maxSize: { type: Number, default: 10 }, // MB
    acceptedTypes: { type: Array, default: ["image/jpeg", "image/png", "image/gif", "image/webp", "image/svg+xml"] }
  }

  connect() {
    this.dragCounter = 0
    if (this.previewUrlValue) {
      this.showPreview(this.previewUrlValue)
    }
  }

  // Drag & Drop handlers
  dragenter(event) {
    event.preventDefault()
    this.dragCounter++
    this.element.classList.add("drag-over")
  }

  dragleave(event) {
    event.preventDefault()
    this.dragCounter--
    if (this.dragCounter === 0) {
      this.element.classList.remove("drag-over")
    }
  }

  dragover(event) {
    event.preventDefault()
  }

  drop(event) {
    event.preventDefault()
    this.dragCounter = 0
    this.element.classList.remove("drag-over")

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.handleFile(files[0])
    }
  }

  // Click to select file
  selectFile() {
    this.inputTarget.click()
  }

  // File input change
  fileSelected(event) {
    const file = event.target.files[0]
    if (file) {
      this.handleFile(file)
    }
  }

  handleFile(file) {
    // Validate file type
    if (!this.acceptedTypesValue.includes(file.type)) {
      alert(`Tipo de archivo no permitido. Usa: ${this.acceptedTypesValue.map(t => t.split('/')[1]).join(', ')}`)
      return
    }

    // Validate file size
    const maxSizeBytes = this.maxSizeValue * 1024 * 1024
    if (file.size > maxSizeBytes) {
      alert(`El archivo es demasiado grande. Máximo: ${this.maxSizeValue}MB`)
      return
    }

    // Update the file input
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.inputTarget.files = dataTransfer.files

    // Clear the remove flag if it exists
    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = ""
    }

    // Show preview
    const reader = new FileReader()
    reader.onload = (e) => {
      this.showPreview(e.target.result, file.name)
    }
    reader.readAsDataURL(file)
  }

  showPreview(url, filename = null) {
    // Hide placeholder, show preview
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("hidden")
    }

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.remove("hidden")
      const img = this.previewTarget.querySelector("img")
      if (img) {
        img.src = url
      }
    }

    if (this.hasFilenameTarget && filename) {
      this.filenameTarget.textContent = filename
    }
  }

  remove(event) {
    event.preventDefault()
    event.stopPropagation()

    // Clear the file input
    this.inputTarget.value = ""

    // Set the remove flag
    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = "1"
    }

    // Hide preview, show placeholder
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
    }

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove("hidden")
    }

    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = ""
    }
  }
}
